import { useState, useEffect } from 'react';
import db from '../services/db';

function normArr(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.filter(Boolean);
  return Object.values(raw).filter(Boolean);
}

export function useSiteSettings(site = 'alsami', skip = false) {
  const cacheKey = `ss_${site}`;

  const getInitial = () => {
    try {
      const c = sessionStorage.getItem(cacheKey);
      return c ? JSON.parse(c) : null;
    } catch { return null; }
  };

  const [raw, setRaw] = useState(getInitial);
  const [loading, setLoading] = useState(() => !getInitial());

  useEffect(() => {
    if (skip) return;
    const unsub = db.subscribeDoc('settings', site, (v) => {
      const data = v || {};
      setRaw(data);
      setLoading(false);
      try { sessionStorage.setItem(cacheKey, JSON.stringify(data)); } catch {}
    });
    return unsub;
  }, [site, skip, cacheKey]);

  const s = raw || {};
  const banners = normArr(s.banners)
    .filter(b => b.active)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  return {
    general:      s.general      || {},
    banners,
    announcement: s.announcement || {},
    whatsapp:     s.whatsapp     || {},
    sale:         s.sale         || {},
    social:       s.social       || {},
    seo:          s.seo          || {},
    popup:        s.popup        || {},
    loading,
  };
}
